import { ElementRef } from '@angular/core';
import * as markerjs2 from 'markerjs2';

function getSafeAreaInsetTop(): number {
  // Read the iOS safe area inset at runtime to avoid toolbar overlapping the status bar
  const div = document.createElement('div');
  div.style.paddingTop = 'env(safe-area-inset-top)';
  div.style.position = 'fixed';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const safeAreaTop = parseInt(getComputedStyle(div).paddingTop, 10) || 0;
  document.body.removeChild(div);
  return safeAreaTop;
}

export function getMarkerJsArea(elementRef: ElementRef): markerjs2.MarkerArea {
  const markerArea = new markerjs2.MarkerArea(elementRef.nativeElement);
  markerArea.settings.displayMode = 'popup';
  markerArea.settings.popupMargin = getSafeAreaInsetTop();
  markerArea.uiStyleSettings.toolbarColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--alberta-color-primary-variant-contrast')
    .trim();
  markerArea.uiStyleSettings.toolbarBackgroundColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--alberta-color-primary-variant')
    .trim();
  markerArea.uiStyleSettings.toolbarBackgroundHoverColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--alberta-color-primary-variant-shade')
    .trim();
  markerArea.settings.defaultColorSet = ['red', 'green', 'blue', 'yellow', 'purple', 'black'];
  markerArea.availableMarkerTypes = [markerjs2.ArrowMarker, markerjs2.FreehandMarker];
  markerArea.renderImageType = 'image/jpeg';
  return markerArea;
}
